export default __webpack_public_path__ + "static/media/pending-icon.ee50452d.svg";